module.exports = __webpack_public_path__ + "static/media/bg_img.5dde80e5.png";